import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

/**
 * Wrapper de los endpoints /liftlogic/garantias (Task 5).
 *
 * No maneja estado (no usa useState): cada método retorna la Promise del
 * axios. El componente que lo consume es el responsable de guardar datos,
 * loading y errores. Calcado de useMenuItemsApi.js.
 */
const useGarantiasApi = () => {
  const list = useCallback(async (tenantId) => {
    const { data } = await axios.get(`${API_PATH}/liftlogic/garantias?tenantId=${tenantId}`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const create = useCallback(async (payload) => {
    const { data } = await axios.post(`${API_PATH}/liftlogic/garantias`, payload, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const update = useCallback(async (id, tenantId, payload) => {
    const { data } = await axios.put(
      `${API_PATH}/liftlogic/garantias/${id}`,
      { ...payload, tenantId },
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const remove = useCallback(async (id, tenantId) => {
    const { data } = await axios.delete(
      `${API_PATH}/liftlogic/garantias/${id}?tenantId=${tenantId}`,
      { headers: authHeaders() }
    );
    return data;
  }, []);

  return useMemo(
    () => ({
      list,
      create,
      update,
      remove,
    }),
    [list, create, update, remove]
  );
};

export default useGarantiasApi;
